const defaultState = {
  shouldRefresh: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "SHOULD_REFRESH": {
      return {
        ...state,
        shouldRefresh: true
      };
    }
    case "SHOULD_NOT_REFRESH": {
      return {
        ...state,
        shouldRefresh: false
      };
    }
    default:
      return state;
  }
};
